import { Button } from "./ui/button";
import { Heart, Stars, Moon } from "lucide-react";
import loveReportBook from "../../../assets/images/love-report/1.webp";

const HeroSection = () => {

  const handleScrollToPricing = () => {
    const element = document.getElementById("pricing-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="min-h-screen bg-background_lv relative overflow-hidden">
      {/* Decorative Elements */}
      
        <div className="absolute top-10 left-4 sm:top-20 sm:left-10 text-love-pink/20 animate-pulse">
          <Heart className="h-6 w-6 sm:h-8 sm:w-8" />
        </div>
        <div className="absolute top-20 right-4 sm:top-40 sm:right-20 text-love-pink/20 animate-pulse delay-1000">
          <Stars className="h-8 w-8 sm:h-12 sm:w-12" />
        </div>
        <div className="absolute bottom-24 left-4 sm:bottom-32 sm:left-20 text-love-pink/20 animate-pulse delay-500">
          <Moon className="h-6 w-6 sm:h-10 sm:w-10" />
        </div>
      

      <div className="container mx-auto px-4 py-8 sm:py-12 lg:py-20">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6 lg:space-y-8 text-center lg:text-left">
            <div className="space-y-3 lg:space-y-4">
              <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold leading-tight">
                Love - A Mystery{" "}
                <span className="block lg:text-5xl text-love-pink">The Heart Loves To Chase</span>
              </h1>
            </div>

            <div className="space-y-3 lg:space-y-4 text-base lg:text-lg text-muted_lv-foreground">
              <p className="font-semibold text-foreground_lv">
                A Soulful Love Report by Acharya LavBhushan to Decode the Secrets of Your Heart
              </p>

              <div className="space-y-2">
                <p>
                  <strong>Love</strong>—a complicated mystery, yet the favourite puzzle to solve.
                </p>
                <p>We fall for the smiles, the silences, the shared glances.</p>
                <p>
                  But sometimes, even with everything in place,{" "}
                  <strong className="text-love-pink">something still feels missing.</strong>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-4">
              <Button onClick={handleScrollToPricing} variant="love" size="lg" className="text-base lg:text-lg px-6 lg:px-8 py-3 lg:py-4 w-full pointer sm:w-auto">
                Get Your Report Now
              </Button>

            </div>
          </div>

          {/* Right Content - Book Image */}
          <div className="flex justify-center lg:justify-end order-first lg:order-last">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-love-pink/20 to-mystical/20 rounded-3xl blur-2xl transform rotate-6"></div>
              <img
                src={loveReportBook}
                alt="Your Love Report - Astrology Book"
                className="relative h-64 sm:h-80 lg:h-96 xl:h-[500px] w-auto object-contain drop-shadow-2xl transform hover:scale-105 transition-transform duration-500"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom CTA Bar */}
      <div className="absolute bottom-0 left-0 right-0 bg-love-pink text-love-pink-foreground py-3 lg:py-4">
        <div className="container mx-auto px-4 flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-2 sm:gap-4">
          <Button onClick={handleScrollToPricing} variant="secondary" size="sm" className="w-full sm:w-auto">
            Get Your Report
          </Button>
          <span className="font-bold text-sm lg:text-lg text-center">Hurry!! Offer Ends Soon</span>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;